import React, { useState, useEffect } from 'react';
import '../styles/HideTextStyle.css'

const RedactedText = ({ originalText, characters = '幽霊心死天下無双知全大小血地' }) => {
  const [displayText, setDisplayText] = useState(originalText);

  useEffect(() => {
    const interval = setInterval(() => {
      const newText = originalText
        .split('')
        .map(char => {
            return characters[Math.floor(Math.random() * characters.length)];
        })
        .join('');
      
      setDisplayText(newText);
    }, 40); // Update every millisecond

    return () => clearInterval(interval);
  }, [originalText, characters]);

  return <span>{displayText}</span>;
};

// Usage
function HideText({originalText}) {
  return (
      <p className='redacted'><RedactedText originalText={originalText}/></p>
  );
};

export default HideText;